import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-294" data-mp="3gpcpu95etf41">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${className} fill-gold text-gold`} aria-hidden="true" data-id="element-295" data-mp="3ks979wj7r56e" data-mpi={i} />)}
    </div>;
}